// Menus & Header Images

// Others
import calender from "../assets/images/calender.png";
import logo from "../assets/images/logo.png";
import edit from "../assets/images/editIcon.png";
import deleted from "../assets/images/deleteIcon.png";
import copy from "../assets/images/copy.png";
import search from "../assets/images/search.png";
import notification from "../assets/images/notification.png";
import arrow from "../assets/images/arrow.png";
import arrowRight from "../assets/images/arrow-right.png";
import arrowLeft from "../assets/images/arrow-left.png";
import shortingArrow from "../assets/images/shortingArrow.png";
import noRecord from "../assets/images/noDataFound.png";
import documenticon from "../assets/images/document-icon.png";
import saveicon from "../assets/images/save-icon.png";
import deleteBtn from "../assets/images/delete.png";
import addIcon from "../assets/images/add-icon.png";
import closeIcon from "../assets/images/close-icon.png";
import closeIconR from "../assets/images/close-icon-r.png";
import binoculars from "../assets/images/Binoculars.png";
import deletecolor from "../assets/images/deletecolor.png";
import printer from "../assets/images/printer.png";
import searchcolor from "../assets/images/searchcolor.png";
import searchDocument from "../assets/images/searchdocument.png";
import warning from "../assets/images/warning.png";
import plusIcon from "../assets/images/plusIcon.png";
import pencilIcon from "../assets/images/pencil.png";
import doneIcon from "../assets/images/done.png";
import cancelIcon from "../assets/images/cancel.png";
import userIcon from "../assets/images/user-line.png";
import unauthorizedImg from "../assets/images/unauthorized.jpg";
import loginImg from "../assets/images/loginnew.png";
import dashboardblack from "../assets/images/dashboardblackicon.png";
import dashboardwhite from "../assets/images/dashboardwhiteicon.png";
import userManagement from "../assets/images/usermanagement.png";
import userManagementwhite from "../assets/images/usermanagementactive.png";
import projectManagement from "../assets/images/projectmanagement.png";
import customerManagement from "../assets/images/customermanagement.png";
import masterData from "../assets/images/masterdata.png";
import masterDataActive from "../assets/images/masterdataactive.png";
import roleManagement from "../assets/images/rolemanagement.png";
import mailTemplate from "../assets/images/mailtemplate.png";
import logout from "../assets/images/logout.png";
import resetPassword from "../assets/images/resetpassword.png";
import navbarcloser from "../assets/images/navbarcloser.png";
import moltechlogo from "../assets/images/moltech_logo.png";
import moltechlogowhite from "../assets/images/moltech_logo02.png";
import moltechlogoSmall from "../assets/images/logo-badge.png";

import customerManagementActive from "../assets/images/customermanagementactive.png";
import projectManagementActive from "../assets/images/projectmanagementactive.png";
import backArrow from "../assets/images/backarrow.png";
import greenAddIcon from "../assets/images/green-pluse.png";

import uploadDocsIcon from "../assets/images/uploadDocsIcon.png";
import profileIcon from "../assets/images/profile.png";

import femaleheader from "../assets/images/female.png";
import maleheader from "../assets/images/male.png";
import userImg from "../assets/images/user.png";
import informationImg from "../assets/images/information.png";
import DescriptionIcon from "@mui/icons-material/Description";

import pdfIcon from "../assets/images/documentIcon/pdf.png";
import DocIcon from "../assets/images/documentIcon/doc.png";
import xlsIcon from "../assets/images/documentIcon/xls.png";
import imgIcon from "../assets/images/documentIcon/img.png";
import zipIcon from "../assets/images/documentIcon/zip.png";
import pptIcon from "../assets/images/documentIcon/ppt.png";
import csvIcon from "../assets/images/documentIcon/csv.png";
import defaultIcon from "../assets/images/documentIcon/defaultIcon.png";

import task from "../assets/images/Task.png";
import bug from "../assets/images/Bug.png";
import story from "../assets/images/Story.png";
import emptyCommentsIcon from "../assets/images/box-empty.png";
import sendIcon from "../assets/images/send-icon.png";
import high from "../assets/images/high_priority.png";
import low from "../assets/images/low_priority.png";
import medium from "../assets/images/medium_priority.png";

import teamIcon from "../assets/images/teamIcon.png";
import subFolder from "../assets/images/sub-folder.png"

import noDataFound from "../assets/images/noDataFound.png";

import boy from "../assets/images/memoji_boy.png";
import girl from "../assets/images/memoji_girl.png";

import vectorCircle from "../assets/images/circle-vector.png";

export const AppIcons = {
  // Menus & Header Images

  // Others
  plusIcon: plusIcon,
  calenderIcon: calender,
  logoImage: logo,
  MoltechLogoWhite: moltechlogowhite,
  editIcon: edit,
  deleteIcon: deleted,
  deleteBtn: deleteBtn,
  copyIcon: copy,
  searchIcon: search,
  notificationIcon: notification,
  arrowIcon: arrow,
  ArrowRight: arrowRight,
  ArrowLeft: arrowLeft,
  userImg: userImg,
  shortingArrowIcon: shortingArrow,
  noRecordImg: noRecord,
  documentIcon: documenticon,
  saveIcon: saveicon,
  AddIcon: addIcon,
  CloseIcon: closeIcon,
  CloseIconR: closeIconR,
  binoculars: binoculars,
  deletecolor: deletecolor,
  printer: printer,
  searchcolor: searchcolor,
  searchDocument: searchDocument,
  warning: warning,
  PencilIcon: pencilIcon,
  DoneIcon: doneIcon,
  CancelIcon: cancelIcon,
  userIcon: userIcon,
  UnauthorizedImg: unauthorizedImg,
  LoginImg: loginImg,
  UploadDocsIcon: uploadDocsIcon,
  ProfileIcon: profileIcon,

  Femaleheader: femaleheader,
  Maleheader: maleheader,

  Information: informationImg,

  Dashboardwhite: dashboardwhite,
  Dashboardblack: dashboardblack,
  Usermanagement: userManagement,
  Usermanagementwhite: userManagementwhite,
  Projectmanagement: projectManagement,
  Projectmanagementactive: projectManagementActive,
  Customermanagement: customerManagement,
  Customermanagementactive: customerManagementActive,
  Masterdata: masterData,
  Masterdataactive: masterDataActive,
  Rolemanagement: roleManagement,
  Mailtemplate: mailTemplate,
  Logout: logout,
  Resetpassword: resetPassword,
  Navbarcloser: navbarcloser,

  Moltechlogo: moltechlogo,
  MoltechlogoSmall: moltechlogoSmall,
  DescriptionIcon: DescriptionIcon,
  BackArrow: backArrow,
  GreenAddIcon: greenAddIcon,
  emptyCommentsIcon: emptyCommentsIcon,
  sendIcon: sendIcon,

  PdfIcon: pdfIcon,
  DocIcon: DocIcon,
  XlsIcon: xlsIcon,
  ImgIcon: imgIcon,
  ZipIcon: zipIcon,
  PptIcon: pptIcon,
  CsvIcon: csvIcon,
  DefaultIcon: defaultIcon,

  Task: task,
  Bug: bug,
  Story: story,

  High: high,
  Low: low,
  Medium: medium,

  TeamIcon:teamIcon,
  SubFolder:subFolder,

  NoDataFound: noDataFound, 

  Boy: boy,
  Girl: girl,

  VectorCircle: vectorCircle,
};
